import { motion } from 'framer-motion';

import { nl2br } from '../../../utils';

import styles from './TimeLineContent.module.css';

const content = {
  initial: {
    opacity: 0,
    y: 10,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.5,
    },
  },
};

interface Props {
  title: string;
  role: string;
  description: string;
  animate: 'visible' | '';
  isLast: boolean;
}

export default function TimeLineContent({ title, role, description, animate, isLast }: Props) {
  const bar = {
    initial: {
      bottom: '100%',
    },
    visible: {
      bottom: isLast ? '0%' : '-20%',
      transition: {
        duration: 4,
        ease: [0, 0.55, 0.45, 1],
      },
    },
  };

  return (
    <div className={styles.content}>
      <motion.div
        className={styles.lineBar}
        variants={bar}
        initial="initial"
        animate={animate || 'initial'}
      />
      <motion.div
        className={styles.inner}
        variants={content}
        initial="initial"
        animate={animate || 'initial'}
      >
        <h3 className={styles.title}>{title}</h3>
        <h4 className={styles.role}>{role}</h4>
        <p className={styles.description}>{nl2br(description)}</p>
      </motion.div>
    </div>
  );
}
